// Arrange flyout for the node context menu (ENG-1069). One consumer now that
// NodeContextMenu is itself shared, so the body / face / event menus can't
// drift. Presentational only: it renders the rows and calls onRun('<op>').
// The op tokens match graphArrange + arrangeShortcutFor exactly.
//
// Align / Distribute / Straighten act on the current multi-selection; Tidy lays
// out the whole graph. Labels and chord hints mirror Unreal's graph editor.

export const ARRANGE_GROUPS = [
  {
    label: 'Align',
    rows: [
      ['align:left', 'Align Left', '⇧A'],
      ['align:centerX', 'Align Center', '⇧⌥S'],
      ['align:right', 'Align Right', '⇧D'],
      ['align:top', 'Align Top', '⇧W'],
      ['align:centerY', 'Align Middle', '⇧⌥W'],
      ['align:bottom', 'Align Bottom', '⇧S'],
    ],
  },
  {
    label: 'Distribute',
    rows: [
      ['distribute:x', 'Distribute Horizontally', ''],
      ['distribute:y', 'Distribute Vertically', ''],
    ],
  },
  {
    label: 'Connections',
    rows: [['straighten', 'Straighten Connections', 'Q']],
  },
  // Tidy (whole-graph) is the canvas toolbar's "Tidy" button, not a menu row.
]

const rowStyle = {
  display: 'flex', justifyContent: 'space-between', gap: 12,
  padding: '6px 12px', cursor: 'pointer', color: 'var(--m-fg-2, #aaa)',
}
const hover = (on) => (e) => { e.currentTarget.style.background = on ? 'var(--m-panel-hi, #1f1f1f)' : 'transparent' }

// There is no Back row: it existed because this list REPLACED the node menu, so
// there had to be a way out. It renders as a flyout now, with the parent menu
// still on screen, and a Back row that returns to something already visible is
// noise.
export function ArrangeMenuItems({ onRun }) {
  return (
    <div>
      {ARRANGE_GROUPS.map((g) => (
        <div key={g.label}>
          <div style={{ padding: '5px 12px 2px', fontSize: 9, letterSpacing: 0.5, textTransform: 'uppercase', color: 'var(--m-fg-3, #666)' }}>{g.label}</div>
          {g.rows.map(([op, label, chord]) => (
            <div
              key={op}
              onClick={() => onRun(op)}
              style={rowStyle}
              onMouseEnter={hover(true)} onMouseLeave={hover(false)}
            >
              <span>{label}</span>
              {chord && <span style={{ color: 'var(--m-fg-3, #666)', fontSize: 10 }}>{chord}</span>}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
